var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E9DDD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9ZM14.5 12L9.49998 12C8.67156 12 8 12.6716 8 13.5C8 14.6161 8.45897 15.5103 9.21215 16.1148C9.95342 16.7098 10.9469 17 12 17C13.0531 17 14.0466 16.7098 14.7879 16.1148C15.541 15.5103 16 14.6161 16 13.5C16 12.6716 15.3284 12 14.5 12ZM9.49998 13L14.5 13C14.7761 13 15 13.2239 15 13.5C15 14.3169 14.6755 14.9227 14.1619 15.3349C13.6364 15.7567 12.8799 16 12 16C11.1201 16 10.3636 15.7567 9.8381 15.3349C9.32453 14.9227 9 14.3169 9 13.5C9 13.2239 9.22387 13 9.49998 13Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.41ff907e86a3241d11d9c7d9f6a8ce73.svg";
export { ForwardRef as ReactComponent };